
namespace Gamification.Gamification {
    export class MailColumns {
        static columnsKey = 'Gamification.Mail';
    }
}